import { NgModule } from '@angular/core';
import { PoolsRoutingModule } from './routing/pools-routing.module';

@NgModule({
  imports: [PoolsRoutingModule]
})
export class PoolsModule {}
